import { createResourceAtom } from 'lib/atoms';
import type { IdentificationResponse } from '../types-identification';
import { buildSectionMutationAtom } from 'lib/atoms/section-mutation';

// ---------------------------------------------------------------------------
// Identification section data layer. Identification is one document-level
// section (per-AfeHeader columns shared across the document's headers), so the
// detail uses a single `createResourceAtom`. Edit + confirm/revert are uniform
// { url, method, data } mutation atoms (mirrors `atoms/wells.ts`).
// ---------------------------------------------------------------------------

export const createIdentificationResourceAtom = (href: string | undefined) =>
  createResourceAtom<IdentificationResponse>(href);

export const identificationUrl = (documentId: number | string) =>
  `/documents/${documentId}/afe_structuring/identification`;

/** Edit identification fields (PATCH .../identification). */
export const editIdentificationAtom =
  buildSectionMutationAtom<IdentificationResponse>();

/** Mark identification as correct (POST .../identification/confirmation). */
export const confirmIdentificationAtom =
  buildSectionMutationAtom<IdentificationResponse>();

/** Remove correct status (DELETE .../identification/confirmation). */
export const revertIdentificationAtom =
  buildSectionMutationAtom<IdentificationResponse>();
